import { HTTPError } from 'ky';

import { fastApi } from '@/services/api';

const PATH = 'v1/referral';

export const postReferral = async (referralCode: string) => {
  await fastApi.post(`${PATH}/${referralCode}`).catch((error) => {
    if (error instanceof HTTPError && error.response.status === 404) return;

    throw error;
  });
};
